export const baseOrderReturn = {
	id: "",
	code: "",
	dealer_id: "",
	type_document: "",
	order_sale_id: "",
	order_delivery_id: "",
	observations: "",

	details: [],
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999,
	}),
};
